import { calculatePowerProfileStats } from 'pages/Blueprints/utils';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PowerProfileDataPoint } from 'greener-ui-library';
import { Locale, localizedNumber } from 'utils/localization';

interface PowerProfileStatsDisplayProps {
  sx?: SxProps<Theme>;
  gap?: number;
  profileData?: PowerProfileDataPoint[];
  locale?: Locale;
}

export const PowerProfileStatsDisplay = ({
  sx,
  gap = 4,
  profileData = [],
  locale = 'en-GB'
}: PowerProfileStatsDisplayProps) => {
  const { t } = useTranslation();
  const stats = calculatePowerProfileStats(profileData);

  return (
    <Box sx={{ display: 'flex', gap, mb: 3, ...sx }}>
      <Box>
        <Typography variant="caption" color="grey.800">
          {t('blueprints:wizard.fields.peakPower')}
        </Typography>
        <Typography data-testid="peak-power-value" variant="body1">
          {localizedNumber({ value: stats.peakPower, unitLabel: 'kW', fractionDigits: 1, locale })}
        </Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="grey.800">
          {t('blueprints:wizard.fields.averagePower')}
        </Typography>
        <Typography data-testid="average-power-value" variant="body1">
          {localizedNumber({ value: stats.averagePower, unitLabel: 'kW', fractionDigits: 1, locale })}
        </Typography>
      </Box>
    </Box>
  );
};
